import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Sidebar as SidebarSemantic, Icon, Accordion } from 'semantic-ui-react';
import './Sidebar.scss';

export default function Sidebar({ toogleSidebar, sidebarVisible }) {
    const [activeIndex, setIndex] = useState(-1);

    function handleClick(_, { index }) {
        setIndex(activeIndex === index ? -1 : index);
    }

    return (
        <SidebarSemantic
            id="sidebar-restaurante"
            as={Menu}
            animation="overlay"
            className="custom-sidebar d-print-none d-flex bordeless"
            inverted
            vertical
            onHide={() => toogleSidebar(false)}
            visible={sidebarVisible}
        >
            <Menu.Item as={Link} identifier="home" link to="/restaurante/inicio">
                <Icon name="home" className="sidebar-icon" /> Início
            </Menu.Item>
            <Accordion inverted className="item p-0">
                <Accordion.Title
                    index={2}
                    active={activeIndex === 2}
                    onClick={handleClick}
                    className="p-0"
                >
                    <Menu.Item>
                        Fechamento de Caixa <Icon name="dropdown" /> <Icon name="calculator" />
                    </Menu.Item>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 2} className="p-0">
                    <Accordion inverted className="item p-0 m-0">
                        <Menu.Item
                            className="editItemSidebar"
                            as={Link}
                            link
                            to="/restaurante/fechamento-de-caixa/incluir-caixa"
                            content="Incluir Caixa"
                        />
                        <Menu.Item
                            className="editItemSidebar"
                            as={Link}
                            link
                            to="/restaurante/fechamento-de-caixa/incluir-outras-receitas"
                            content="Incluir Outras Receitas"
                        />
                        <Menu.Item
                            className="editItemSidebar"
                            as={Link}
                            link
                            to="/restaurante/fechamento-de-caixa/consultar-alterar-caixa"
                            content="Consultar/Alterar Caixa"
                        />
                    </Accordion>
                </Accordion.Content>

                <Accordion.Title
                    index={4}
                    active={activeIndex === 4}
                    onClick={handleClick}
                    className="p-0"
                >
                    <Menu.Item>
                        Movimentação
                        <Icon name="dropdown" />
                    </Menu.Item>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 4} className="p-0">
                    <Accordion inverted className="item p-0 m-0">
                        <Menu.Item
                            className="editItemSidebar"
                            as={Link}
                            link
                            to="/restaurante/movimentacao/extrato-resumo"
                            content="Extrato/Resumo"
                        />
                        <Menu.Item
                            className="editItemSidebar"
                            as={Link}
                            link
                            to="/restaurante/movimentacao/resumo-rede"
                            content="Resumo-Rede"
                        />
                    </Accordion>
                </Accordion.Content>

                <Accordion.Title
                    index={6}
                    active={activeIndex === 6}
                    onClick={handleClick}
                    className="p-0"
                >
                    <Menu.Item>
                        Conciliação de Cartões
                        <Icon name="dropdown" />
                    </Menu.Item>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 6} className="p-0">
                    <Accordion inverted className="item p-0 m-0">
                        <Menu.Item
                            className="editItemSidebar"
                            as={Link}
                            link
                            to="/restaurante/conciliacao-cartao/upload"
                            content="Upload Extrato de Cartões"
                        />
                        <Menu.Item
                            className="editItemSidebar"
                            as={Link}
                            link
                            to="/restaurante/conciliacao-cartao/extrato"
                            content="Extrato de Cartões"
                        />
                        <Menu.Item
                            className="editItemSidebar"
                            as={Link}
                            link
                            to="/restaurante/conciliacao-cartao/cartao-x-caixa"
                            content="Conciliação Cartão x Caixa"
                        />
                    </Accordion>
                </Accordion.Content>

                <Accordion.Title
                    index={3}
                    active={activeIndex === 3}
                    onClick={handleClick}
                    className="p-0"
                >
                    <Menu.Item>
                        Contas à Pagar (Central)
                        <Icon name="dropdown" />
                    </Menu.Item>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 3} className="p-0">
                    <Accordion inverted className="item p-0 m-0">
                        <Menu.Item
                            className="editItemSidebar"
                            as={Link}
                            link
                            to="/restaurante/contas-a-pagar/relatorio"
                            content="Relatório"
                        />
                    </Accordion>
                </Accordion.Content>
            </Accordion>
        </SidebarSemantic>
    );
}
